import React, { Fragment, useEffect } from 'react'
import { change, Field } from 'redux-form';
import { AutoCompleteSelect, InputWithIcon } from '../../../../../../itrust_common/components/form';
import DiscountField from '../../DiscountField';
import { connect, useDispatch } from 'react-redux';
import { useCurrentTypeHook } from '../../../../../../itrust_common/components/others/helperHooks/useCurrentTypeHook';

function LensType(props) {
  const { pprops, member, fields, orderStoreId, currentStoreOtherDetails, eyeTestType, currentEyeglass, glassModule } = props
  const dispatch = useDispatch()
  const currency = useCurrentTypeHook();

  useEffect(() => {
    handleSetLenses()
  }, [currentEyeglass?.lens_types_attributes])

  const handleSetLenses = () => {
    if (currentEyeglass && currentEyeglass?.lens_types_attributes?.length !== 0 && currentStoreOtherDetails?.stock_lens) {
      // OD, OS lens
      setOdOsLensAttributes()
    }
    if (currentEyeglass && !currentEyeglass?.lens_types_attributes?.length) {
      // Only One for old flow
      setDefaultStructure()
    }
  }

  const setOdOsLensAttributes = () => {
    if (currentEyeglass?.lens_types_attributes?.length === 2) {
      dispatch(change('orderEyeglassForm', `${member}.lens_types_attributes`, currentEyeglass?.lens_types_attributes));
    }
    else if (currentEyeglass?.lens_types_attributes?.length === 1) {
      let newEyeType = currentEyeglass?.lens_types_attributes[0]?.eye_type === 'od' ? 'os' : 'od'
      dispatch(change('orderEyeglassForm', `${member}.lens_types_attributes`, [{ ...currentEyeglass?.lens_types_attributes[0] }, { ...DefaultVals, eye_type: newEyeType }]));
    }
  }

  const DefaultVals = {
    settings_eyeglass_lens_type_id: null,
    discount_type: 'cash',
    unit_price: null,
    copay: null,
    cash_discount: null,
    percentage_discount: null,
  }

  const setDefaultStructure = () => {
    if (currentStoreOtherDetails?.stock_lens) {
      dispatch(change('orderEyeglassForm', `${member}.lens_types_attributes`, [{ ...DefaultVals, eye_type: 'od' }, { ...DefaultVals, eye_type: 'os' }]));
    }
    else {
      dispatch(change('orderEyeglassForm', `${member}.lens_types_attributes`, [DefaultVals]));
    }
  }

  const handleLenseSelect = (data, lensMember) => {
    dispatch(change('orderEyeglassForm', `${lensMember}[settings_eyeglass_lens_type_id]`, data.id));
    dispatch(change('orderEyeglassForm', `${lensMember}[name]`, data.lens_type));
    setTimeout(() => pprops.submit(), 500)
  }

  const getStoreIdForSearch = () => {
    let StoreId = localStorage.getItem('StoreID')
    if (!StoreId && StoreId == null) {
      return orderStoreId
    }
    return StoreId
  }

  const handleRemoveLens = (lensMember) => {
    dispatch(change('orderEyeglassForm', `${lensMember}[_destroy]`, true));
    setTimeout(() => pprops.submit(), 500)
  }

  const renderLensType = ({ lensMember, index, members }) => {
    return (
      <Fragment key={`${members.get(index).eye_type}-${lensMember}`}>
        <Field
          name={`${lensMember}[settings_eyeglass_lens_type_id]`}
          displayName={`${lensMember}[name]`}
          component={AutoCompleteSelect}
          onChangeHook={(data) => handleLenseSelect(data, lensMember)}
          klass="Settings::EyeglassLensType"
          additionalFilters={{ store_inventory: getStoreIdForSearch() }}
          textField="lens_type"
          valueField="id"
          placeholder="Placeholder"
          wrapperClasses={`${glassModule ? 'col-2' : 'col-4'} form-group`}
          className="form-control"
          label={`${glassModule ? `${members.get(index).eye_type === 'od' ? 'OD Lens' : 'OS Lens'}` : ''} Type`}
          labelClasses="w-100"
          onResetVal={() => handleRemoveLens(lensMember)}
        />
        <Field name={`${lensMember}[unit_price]`} type="number" component={InputWithIcon} title={currency.symbol} label="Unit Price" labelClasses="w-100" className="form-control" wrapperClasses={`${glassModule ? 'col-1' : 'col-2 px-2'} form-group`} />
        <Field name={`${lensMember}[copay]`} component={InputWithIcon} title={currency.symbol} label="Copay" labelClasses="w-100" className="form-control" wrapperClasses={`${glassModule ? 'col-1' : 'col-2 px-3'} form-group`} />
        <div className={`${glassModule ? 'col-2' : 'col-3'}`}>
          <label>Discount</label>
          <DiscountField
            cashName={`${lensMember}[cash_discount]`}
            percentageName={`${lensMember}[percentage_discount]`}
            discountTypeName={`${lensMember}[discount_type]`}
            defaultType={members.get(index).discount_type}
            prependClasses="py-2"
          />
        </div>
      </Fragment>
    )
  }

  return (
    <>
      {fields.map((lensMember, index, members) => (
        (!eyeTestType || (eyeTestType && eyeTestType === members.get(index).eye_type)) && renderLensType({ lensMember, index, members })
      ))}
    </>
  )
}

const mapStateToProps = (state) => {
  const { order: { order }, currentStore } = state
  return {
    orderStoreId: order.store_id,
    currentStoreOtherDetails: currentStore.store?.other_details
  }
}

export default connect(mapStateToProps)(LensType);